import React from 'react';
import { TrevorComponent } from '@trevor/ui-components';
import styled from 'styled-components';

const PublicDatasetHintsList: TrevorComponent = ({ className }) => {
  return (
    <div className={className}>
      <h3>Learn how to customize public datasets</h3>
      <span>
        Just hover over the numbered sections on the query builder and click on
        the pencil icon.
      </span>
      <span>Change the parameters on the modal view and click DONE.</span>
      <span>Your new custom dataset will immediately appear on the table.</span>
      <span>
        Save the URL to checkback later or use Share button to share with your
        team members and community!
      </span>
    </div>
  );
};

export default styled(PublicDatasetHintsList)`
  background: #061e2d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  height: 248px;
  width: 399px;
  padding: 16px 20px 23px 16px;
  color: #ffffff;
  counter-reset: num;

  display: flex;
  flex-direction: column;
  gap: 15px;

  & > h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 29px;
    margin: 0;
  }

  & > span {
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 18px;
    position: relative;
    padding-left: 30px;
  }

  > span::before {
    counter-increment: num;
    content: counter(num);
    display: inline-flex;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;

    width: 23px;
    height: 23px;

    background: #ffffff;

    border: 1px solid #cccccc;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;

    color: #061e2d;
  }
`;
